import React from 'react';
// import ProvisioningStyles from 'pages/myidm/style';
import { OrderPayload, toggleSspModels, selectedMembersList } from 'pages/myidm/store';
// import { getSelectMemberBtnStatus } from 'pages/myidm/utils';
import Btn from 'components/button';
import { useRecoilState, useRecoilValue } from 'recoil';
import { commonStyles as style } from 'assets/style';
import PropTypes from 'prop-types';
import ProvisioningStyles from 'pages/provisioning/vm/style';
import { Badge, Box } from '@mui/material';

const MultipleSelectMemberBtn = ({ index = 0 }) => {
    // const [isLoading, setLoading] = React.useState(false);
    const [modal, setModal] = useRecoilState(toggleSspModels);
    const [selectedMemList, setSelectedMemList] = useRecoilState(selectedMembersList);
    const order = useRecoilValue(OrderPayload);
    // Disable if adGroup is null for this index
    const isAdGroupSelected = order?.multipleAdGroups && order.multipleAdGroups[index]?.adGroup;
    const handleOpenMemlistModal = () => {
        if (order?.members?.length !== selectedMemList?.length) {
            setSelectedMemList(order?.members);
        }
        // setLoading(true);
        setModal({ ...modal, isMultipleMemberlist: true, index });

        // setLoading(false);
    };
    // const isValid = getSelectMemberBtnStatus({ order })?.isValid;
    return (
        <Box sx={ProvisioningStyles.dataDisk.btnWrapper}>
            <Badge
                sx={{ ...ProvisioningStyles.dataDisk.badgeWidth, width: 'auto' }}
                overlap="circular"
                color="error"
                variant={!order?.multipleAdGroups[index]?.members?.length ? 'dot' : 'standard'}
            >
                <Btn
                    // color="cmpPrimary"
                    data-testid="select-mem-btn"
                    className="btn-disabled"
                    disabled={!isAdGroupSelected}
                    variant="contained"
                    // sx={ProvisioningStyles?.selectMemBtn}
                    sx={{ ...style.primaryMediumButton, width: '166px' }}
                    onClick={() => {
                        handleOpenMemlistModal();
                    }}
                >
                    Select Member
                </Btn>
            </Badge>
        </Box>
    );
};
MultipleSelectMemberBtn.propTypes = {
    index: PropTypes.number,
};
MultipleSelectMemberBtn.defaultProps = {
    index: 0,
};
export default MultipleSelectMemberBtn;
